import type { NutrafolAcademyCourse } from "@/types/nutrafolAcademy";
import { GA4 } from "@/utils/ga4Utils";
import { getVideoProgress } from "@/utils/videoTracking";

import CourseInfoPanel from "./CourseInfoPanel";
import CourseModalShell from "./CourseModalShell";

export interface AdditionalCourseModalProps {
  course: NutrafolAcademyCourse;
  closeModal: () => void;
}

const AdditionalCourseModal = ({ course, closeModal }: AdditionalCourseModalProps) => (
  <CourseModalShell closeModal={closeModal}>
    <div className="flex flex-col lg:flex-row gap-4 lg:gap-12 max-w-[400px] md:max-w-none mx-auto w-full h-full">
      <div className="w-full lg:w-[59%]">
        <CourseInfoPanel course={course} tagLabel={course.tag} />
      </div>
      <div className="w-full h-full lg:w-[41%] overflow-hidden">
        <video
          className="w-full h-full object-contain md:object-cover bg-[black]"
          poster={course.video?.poster}
          controls
          autoPlay
          playsInline
          onPlay={(e) => {
            GA4.onVideoPlayed({
              module_state: "Play",
              video_name: course.title,
              video_url: course.video?.src ?? "",
              video_play_type: "autoplay",
              ...getVideoProgress(e.currentTarget),
            });
          }}
          onPause={(e) => {
            if (e.currentTarget.ended) return;
            GA4.onVideoPlayed({
              module_state: "Paused",
              video_name: course.title,
              video_url: course.video?.src ?? "",
              video_play_type: "autoplay",
              ...getVideoProgress(e.currentTarget),
            });
          }}
        >
          {course.video?.src ? <source src={course.video.src} type="video/mp4" /> : null}
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </CourseModalShell>
);

export default AdditionalCourseModal;
